<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('settings.dunning_settings.form.damage_compensation_line_text')"
                    :hint="__('settings.dunning_settings.form.damage_compensation_line_text_translation_hint')"
                >
                    <DInput
                        id="damage_compensation_line_text"
                        v-model="form.translations[key].damage_compensation_line_text.value"
                        :is-valid="isFormFieldValid('damage_compensation_line_text')"
                        maxlength="255"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="$route('settings.dunning-settings.create')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    reminderSetting: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('settings.dunning-settings.translations-update', { reminderSetting: props.reminderSetting.id ?? 0 }))
}

const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value
    ? `${__('settings.default_customer_language')} ${translation.language.label}`
    : translation.language.label

</script>

<style scoped lang="scss">

</style>
